/**
 * Hamburger Menu on mobile.
 */

const hamburgerMenu = function() {
  const btn = document.querySelector(".header__hamburger");
  const nav = document.querySelector(".header__nav");
  const text = document.querySelector(".header__hamburger-text");
  const items = document.querySelectorAll(".js-nav-item");

  if (screen.width < 768) {

    const openMenu = function() {
      btn.classList.add("active");
      nav.classList.add("active");
      text.textContent = "CLOSE";
    };

    const closeMenu = function() {
      btn.classList.remove("active");
      nav.classList.remove("active");
      text.textContent = "MENU";
    };

    // Hamburger menu functionality.
    btn.addEventListener("click", function(e) {
      if(!btn.classList.contains("active")) openMenu();
      else closeMenu();
    });

    // Close menu when anchor is clicked.
    items.forEach(item => item.addEventListener("click", closeMenu));
  }
};

export default hamburgerMenu;